import Image from 'next/image'
import Link from 'next/link'
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'
import Breadcrumbs from '@/components/Secondary/Breadcrumbs/Breadcrumbs'


interface BlogHeroMainProps {
	heading?: {
		title?: string
	}
	text?: {
		text?: string
	}

	background_desktop?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	background_mobile?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
	button?: {
		href: string
		label: string
	}
}

export const fields = [
	'heading.title',
	'text.text',

	'background_desktop.alt',
	'background_desktop.image_file.image.id',
	'background_desktop.image_file.image.filename_download',
	'background_mobile.alt',
	'background_mobile.image_file.image.id',
	'background_mobile.image_file.image.filename_download',

	'button.href',
	'button.label',
] as const

export default function BlogHeroMain({ data }: { data: BlogHeroMainProps }) {

	return (
		<>
			<section className='BlogHeroMain relative h-[calc(100vh-73px)] sm:h-[500px] bg-white overflow-hidden'>
				{/* Background Image */}
				<div className='absolute inset-0 w-full h-full'>
					<picture>
						<source
							srcSet={getReadableImageUrl(
								data?.background_desktop?.image_file?.image?.id || '',
								data?.background_desktop?.image_file?.image
									?.filename_download || ''
							)}
							media='(min-width: 580px)'
							type='image/webp'
						/>
						<Image
							src={getReadableImageUrl(
								data?.background_mobile?.image_file?.image?.id || '',
								data?.background_mobile?.image_file?.image?.filename_download ||
									''
							)}
							alt={data?.background_mobile?.alt || ''}
							fill
							className='object-cover xl:object-top sm:object-[70%_0] object-center'
							priority
							quality={100}
						/>
					</picture>
				</div>

				{/* Gradient overlay */}
				<div className='absolute inset-x-0 bottom-0 h-[60%] bg-gradient-to-t from-white via-white/100 to-transparent md:hidden' />

				{/* Content */}
				<div className='container h-full relative flex items-end sm:items-center pb-8 sm:pb-0'>
					<div className='flex flex-col w-full max-w-[500px]'>
						<h1
							className='text-4xl md:text-6xl mb-6 sm:mb-8 md:mb-12 tracking-[0.5px]'
							dangerouslySetInnerHTML={sanitizeHTML(data?.heading?.title || '')}
						/>

						{/* Bullets */}
						<div
							className='flex flex-col gap-3 sm:gap-5 md:gap-6 mb-6 sm:mb-8 md:mb-12'
							dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
						/>

						{/* Buttons */}
						<div className='flex flex-col-reverse sm:flex-row items-center gap-3 sm:gap-6'>
							<Link
								href={data?.button?.href || ''}
								className='btn'
							>{data?.button?.label || ''}
							</Link>
						</div>
					</div>
				</div>
			</section>
			<Breadcrumbs data={data} />
		</>
	)
}